import React, { Component } from "react";
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import { Container } from "react-bootstrap";
import { isBrowser } from "react-device-detect";
import { withRouter } from "react-router-dom";
import * as Cookies from "es-cookie";

// Import main-tab subcomponents
import WhatsAppTab from "../components/communication_management/WhatsApp/WhatsAppTab";
import SMSTab from "../components/communication_management/SMS/SMSTab";
import MobileNotificationsTab from "../components/communication_management/MobileNotifications/MobileNotificationsTab";

const ACTIVE_COLOR = "#6366f1";

// Main tab definitions (a, b sub-tabs live inside each tab component)
const MAIN_TABS = [
  { key: "whatsapp", label: "WhatsApp", icon: "fab fa-whatsapp" },
  { key: "sms", label: "SMS", icon: "fal fa-comment-alt-lines" },
  { key: "mobile-notifications", label: "Mobile Notifications", icon: "fal fa-bell" },
];

const DEFAULT_TAB = "whatsapp";

class CommunicationManagement extends Component {
  menuToggler = () => {
    const toggled = Cookies.get("toggle");
    if (toggled === "wrapper") {
      this.setState({ toggled: "wrapper sidebar-enable" });
      Cookies.set("toggle", "wrapper sidebar-enable");
    } else {
      this.setState({ toggled: "wrapper" });
      Cookies.set("toggle", "wrapper");
    }
  };

  handleTabClick = (tab) => {
    this.props.history.push(`/communication-management/${tab}`);
  };

  renderTabContent = (activeTab) => {
    const commonProps = { history: this.props.history };

    switch (activeTab) {
      case "sms":
        return <SMSTab {...commonProps} />;
      case "mobile-notifications":
        return <MobileNotificationsTab {...commonProps} />;
      case "whatsapp":
      default:
        return <WhatsAppTab {...commonProps} />;
    }
  };

  render() {
    if (Cookies.get("token") === undefined) {
      this.props.history.push("/login");
      return null;
    }

    const { tab } = this.props.match.params;
    const activeTab = MAIN_TABS.some((t) => t.key === tab) ? tab : DEFAULT_TAB;

    return (
      <div className={Cookies.get("toggle")}>
        <div className="header-area">
          <NavbarOne onClick={() => this.menuToggler()} />
        </div>
        <div className="main-wrapper">
          <div
            id="sidebar"
            className={
              isBrowser === true
                ? "sidebar-menu d-none d-xl-block d-lg-block"
                : "sidebar-menu d-block d-xl-none d-lg-none"
            }
          >
            <SideNavbar onClick={() => this.menuToggler()} />
          </div>
          <div className="student-overlay" onClick={() => this.menuToggler()} />

          <div className="content-wrapper pt-0">
            <div className="communication-main-container">
              <Container fluid className="px-0">
                <div
                  style={{
                    background: "#fff",
                    borderRadius: 16,
                    boxShadow: "0 4px 24px rgba(0,0,0,0.05)",
                    overflow: "hidden",
                    border: "1px solid #e2e8f0",
                  }}
                >
                  {/* Sub-header with nav tabs — expense / certificate module style */}
                  <div
                    style={{
                      background: "#f8fafc",
                      borderBottom: "1.5px solid #e2e8f0",
                      padding: "12px 24px 0 24px",
                    }}
                  >
                    <ul className="nav nav-tabs" style={{ borderBottom: "none", gap: 8 }}>
                      {MAIN_TABS.map(({ key, label, icon }) => {
                        const isActive = activeTab === key;
                        return (
                          <li className="nav-item" key={key}>
                            <a
                              className={`nav-link ${isActive ? "active" : ""}`}
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                this.handleTabClick(key);
                              }}
                              style={{
                                cursor: "pointer",
                                fontWeight: 700,
                                fontSize: 14,
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                                padding: "12px 20px",
                                color: isActive ? ACTIVE_COLOR : "#4b5563",
                                background: isActive ? "#fff" : "transparent",
                                borderColor: isActive
                                  ? "#e2e8f0 #e2e8f0 #fff"
                                  : "transparent",
                                borderWidth: "1.5px",
                                borderBottomWidth: isActive ? "2px" : "1.5px",
                                borderRadius: "10px 10px 0 0",
                                transition: "all 0.15s ease",
                                marginBottom: "-1.5px",
                                textDecoration: "none",
                              }}
                            >
                              <i className={icon} />
                              {label}
                            </a>
                          </li>
                        );
                      })}
                    </ul>
                  </div>

                  {/* Content panel */}
                  <div style={{ padding: "28px" }}>
                    {this.renderTabContent(activeTab)}
                  </div>
                </div>
              </Container>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

export default withRouter(CommunicationManagement);
